import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

// Whether self-service registration/login is open (admin-configurable toggle,
// see AdminConfig). Defaults to true while loading / on error so the "Log in"
// link doesn't flicker or disappear if the request is slow or fails.
export function usePublicAccess() {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/ai/public-access-config`)
      .then((res) => res.json())
      .then((data) => { if (!cancelled) setEnabled(data.enabled !== false); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return enabled;
}
